import { LoadInventory, type StockListItem, type StockListResponse } from '@anypromo/shared/api/InventoryClient'
import { type SpecItem } from '../../types'
import { type StockStatus } from '@anypromo/shared/types/customize/stock'
import { useWindow } from '../use-window'
import { ProductSpecModel } from '../../model'
import { useSpec } from '../../store/modules/spec'
import bus from '../use-bus'

let stockList: StockListResponse | undefined

export type StockStatusResult = {
  size: string
  status: StockStatus
}
const { productSpecList, specList } = useWindow()

const checkStockStatus = (stock: StockListItem | undefined, qty: number): StockStatus | undefined => {

  if (!stock) return undefined

  const stockResult: StockStatus = {
    status: '',
    eta: '',
    etaTips: ''
  }

  if (stock.qty === '-1') {
    stockResult.status = 'callforStock'
  } else if (stock.qty === '-2') {
    stockResult.status = 'callforStock'
  } else if (stock.qty === '-3') {
    //认为有库存
    stockResult.status = ''
    // 不做处理
  } else {
    const stockQty = parseInt(stock.qty)
    const avail = stockQty - qty

    if (avail >= parseInt(stock.LowStockThreshold)) {
      // 有货
      // 有size
      stockResult.status = 'inStock'
    } else if (avail > 0 && avail < parseInt(stock.LowStockThreshold)) {
      stockResult.status = 'lowStock'
    } else if (stockQty > 0) {
      // stockResult.status = 'insufficientStock'
      stockResult.status = 'lowStock'
    } else {
      // 无货
      // 判断是否有ETA
      if (stock.eta) {
        stockResult.etaTips = stock.eta
        stockResult.eta = stock.eta_time
        stockResult.status = 'outofStock'
      } else {
        stockResult.status = 'outofStock'
      }
    }
  }

  return stockResult
}

const initOutOfStock = (stockList: StockListResponse) => {
  if (!stockList || stockList.Head.length === 0) return
  if (productSpecList.length === 1) {
    //
    const spec = productSpecList[0]
    const specName = spec.name
    if (stockList.Head.includes(specName) === false) {
      return
    }

    spec.values.forEach((it) => {
      it.outOfStock = false
      const values: StockListItem[] = []
      stockList.Body.forEach((stock) => {
        // 查找是否有多条记录
        if (stock[specName] && stock[specName].toLowerCase() === it.value.toLowerCase()) {
          values.push(stock)
        }
      })

      const flag = values.length > 0 && values.every((stock) => {
        const stockQty = parseInt(stock.qty)
        // 查找是否有多条记录
        if (stockQty === -3) {
          return false
        }
        else if (stockQty <= 0 && stockQty > -3) {
          return true
        }
        return false
      })

      if (flag) {
        it.outOfStock = true
      }
    });
  } else if (productSpecList.length > 1) {
    const spNameList: string[] = []
    productSpecList.forEach(function (sp) {
      const specName = sp.name
      if (stockList.Head.includes(specName) === false) {
        return
      }
      spNameList.push(specName)
    })
    if (spNameList.length !== 1) {
      return
    }
    productSpecList.forEach(function (sp) {
      const specName = sp.name

      if (spNameList.includes(specName) === false) {
        return
      }
      sp.values.forEach(function (it) {
        it.outOfStock = false
        const values: StockListItem[] = []
        stockList.Body.forEach(function (stock) {
          if (stock[specName] && stock[specName].toLowerCase() === it.value.toLowerCase()) {
            values.push(stock)
          }
        })
        const flag = values.length > 0 && values.every((stock) => {
          const stockQty = parseInt(stock.qty)
          // 查找是否有多条记录
          if (stockQty <= 0 && stockQty > -3) {
            // it.outOfStock = true
            return true
          }
          return false
        })
        if (flag) {
          it.outOfStock = true
        }
      });
    })
  }
}

// 库存队列
const _queue: ProductSpecModel[] = [];
//库存是否已加载
let _stockLoad = false;
// 库存是否在加载中
let _isLoading = false;

/*
todo: 这里使用队列更合适
  如果库存没加载完成，那就把数据推送到队列里，等库存加载完成后再循环检查库存。
  如果库存加载完成，那就直接检查库存。
 */
const useStock = (
) => {
  const { productId } = useWindow()


  // 如果库存没有加载完成，那就初始化
  if (!_isLoading) {
    _isLoading = true;
    LoadInventory(productId).then(data => {
      _stockLoad = true;
      stockList = data
      initOutOfStock(stockList);
      bus.emit('InventoryLoaded');

      // 开始执行队列信息
      _queue.forEach(it => {
        _getStockStatus(it)
      })

    }).catch(() => {
      _isLoading = false;
    })
  }

  /**
   * 获取库存状态
   * @param val 
   */
  const getStockStatus = (val: ProductSpecModel | ProductSpecModel[]) => {
    const values = Array.isArray(val) ? val : [val];

    // 如果库存没有加载完成，那就初始化
    if (!_stockLoad) {
      _queue.push(...values)
    } else {
      values.forEach(it => {
        _getStockStatus(it)
      })
    }

  }

  const _getStockStatus = (val: ProductSpecModel): void => {

    if (!stockList || stockList.Head.length === 0 || stockList.Body.length === 0) {
      return
    }
    const specState = useSpec()

    const productSpecNames: string[] = []
    if (productSpecList.length > 0) {
      productSpecList.forEach((sp) => {
        if (stockList?.Head.includes(sp.name)) {
          productSpecNames.push(sp.name)
        }
      })
    }

    // spec匹配数量，取自step 2 item options
    const specNameValues: {
      name: string
      value?: SpecItem
    }[] = []

    // 如果step 匹配数量不足，那就用step 2来凑。
    if (productSpecNames.length < stockList.Head.length) {
      // 计算step 2是否有数据
      if (specState.specList.length === 0) {
        return
      }
      specState.specList.forEach((sp) => {
        if (stockList?.Head.includes(sp.name)) {
          specNameValues.push({ name: sp.name, value: sp.selectedItem })
        }
      })
      if (specNameValues.length === 0) {
        return
      }
    }

    if (stockList) {
      // 查找库存
      const stocks = stockList.Body.filter((stock: any) => {

        if (productSpecNames.length > 0) {
          for (const name of productSpecNames) {
            // 先判断spec是否在head里
            // if (stockList?.Head.includes(spec.name) === false) continue
            const specValue = val.productSpec.find((f) => f.name === name)

            if (stock[name] == null) return false
            if (!specValue) return false

            if (stock[name].toLowerCase() !== specValue.value?.value.toLowerCase()) {
              return false
            }
          }
        }


        if (specNameValues.length > 0) {
          for (const { name, value } of specNameValues) {
            if (stockList?.Head.includes(name) === false) return false
            if (!value) return false
            if (stock[name] == null) return false

            if (stock[name].toLowerCase() !== value.value.toLowerCase()) {
              return false
            }
          }
        }

        return true
      })

      if (stocks.length > 0) {
        if (Array.isArray(val.quantity)) {
          val.quantity.forEach((sz) => {
            if (sz.quantity === '' || sz.quantity === 0) {
              return
            }
            let stock: StockListItem | undefined
            for (let i = 0; i < stocks.length; i++) {
              if (stocks[i].size === sz.size) {
                stock = stocks[i]
                break
              }
            }
            if (stock) {
              sz.stock = checkStockStatus(stock, sz.quantity)
              return
            } else {
              //如果没找到，就认为没库存
              sz.stock = {
                status: '',
                eta: '',
                etaTips: ''
              }
            }
          })
        } else {
          const stock: StockListItem | undefined = stocks.length > 0 ? stocks[0] : undefined

          if (val.quantity.quantity !== '') {
            val.quantity.stock = checkStockStatus(stock, val.quantity.quantity)
          }
        }
      } else {
        /*
        如果库存里没找到，就认为是有库存，页面上不显示
         */
        if (Array.isArray(val.quantity)) {
          val.quantity.forEach((sz) => {
            sz.stock = {
              status: '',
              eta: '',
              etaTips: ''
            }
          })
        } else {
          val.quantity.stock = {
            status: '',
            eta: '',
            etaTips: ''
          }
        }
      }
    }

  }
  return {
    getStockStatus
  }
}

export { useStock }
